import { TargetingGroups } from '@src/application/modules/flagship/type';
import { Targeting } from './Targeting';
import styles from '@src/application/modules/shared/styles/CampaignSummary/CampaignSummary.module.scss';

export const TargetingGroup = ({
  targetingGroup,
  isLastGroup,
  keyIndex,
}: {
  targetingGroup: TargetingGroups;
  isLastGroup: boolean;
  keyIndex?: string;
}) => (
  <>
    <div>
      {targetingGroup.targetings.map((targeting, targetIndex) => {
        const isLastTarget = targetingGroup.targetings.length - 1 === targetIndex;
        return (
          <Targeting key={`target-${targetIndex}-${keyIndex}`} targeting={targeting} isLastTarget={isLastTarget} />
        );
      })}
    </div>
    {!isLastGroup && <div className={`${styles.targetingLogicOperator} ${styles.or}`}>OR</div>}
  </>
);
